const content: { [key: string]: string } = {
  title: "Filters",
  clearAll: "Clear All",
  all: "All",
  applyFilters: "Apply Filters{FILTER_COUNT}",
  cancel: "Cancel",
  clearSearch: "Clear search",
};

export default content;
